<style lang="less">
@media only screen and (max-height: 360px) {
	.agreement{
		display: none !important;
	}
}

.agreement{
	width: 100%;
	display: -webkit-box; display:flex;
	-webkit-box-align: center; align-items: center;
	-webkit-box-pack: center; justify-content: center;
	position: fixed;
	bottom: 68px;
	font-size: 10px;
	color: #999;
	z-index: 8;
	img{
		width: 12px;
		margin-right: 6px;
	}
	.book{
		color: #c62520;
		font-weight: 600;
	}
	a{
		color: #c62520;
		font-weight: 700;
	}
}
</style>

<template>
	<!-- Main agreement -->
	<div class="agreement">
		<img v-if="agree" src="./images/icon_multiple.png" @click="toggle" />
		<img v-else src="./images/icon_multiple_disable.png" @click="toggle" />
		<slot name="agree"></slot>
	</div>
</template>

<script>
	export default {
		data: function () {
			return {
			};
		},
		components: {
		},
		props: {
			agree: {
				type: Boolean,
				default: true
			}
		},
		mounted: function () {
		},
		methods: {
			toggle: function () {
				console.log(1);
				this.$emit('toggleAgree');
			}
		}
	};
</script>


// WEBPACK FOOTER //
// ../common-npm/flyme7/component/agreement/agreement.vue